import script from "./EditArtwork.vue?vue&type=script&setup=true&lang=js"
export * from "./EditArtwork.vue?vue&type=script&setup=true&lang=js"

import "./EditArtwork.vue?vue&type=style&index=0&id=1ddbd0d0&lang=css"

const __exports__ = script;

export default __exports__